import { Box, Button, Card, Grid, IconButton, Typography } from "@mui/material";
import React, { useEffect, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useNavigate, useParams } from "react-router-dom";
import { useSnackbar } from "../../Components/Snackbar/SnackBarContext";
import { callAPI, Method } from "../../commonFunctions/CommonFunctions";
import WSTextField, { TextType } from "../../Components/TextBox/WSTextBox";
import WSTextAreaField from "../../Components/WSTextArea/WSTextArea";
import WSFileUpload from "../../Components/FileUpload/WSFileUpload";
import WSButton from "../../Components/Button/WSButton";
import WSSelectField from "../../Components/Select/WSSelect";
import WSMultiSelectField from "../../Components/Multiselect/WSMultiselect";
import {
  HeaderList,
  IHeaderListActions
} from "../../Components/Header/HeaderList";
import { IServiceToProductMap } from "../DTO/DTO";
import { url } from "inspector";
import CollapsibleTable, {
  IColumnsCollapsable
} from "../../Components/DataGrid/WSDataGridCollapsable";
import WSDataGridCollapsable from "../../Components/DataGrid/WSDataGridCollapsable";
import { IColumns } from "../../Components/DataGrid/WSDataGrid";
import { WSIcons } from "../../commonFunctions/iIcons";
import clientconfig from "../../Config/clientConfig.json";
interface FormValues {
  items: {
    productId: string;
    productType: string;
    serviceId: string;
    price: number;
  }[];
}
export const ServiceProductMapping: React.FC<any> = React.memo((props) => {
  const navigate = useNavigate();
  const params = useParams();
  const id = params?.id;
  const { showMessage } = useSnackbar();
  const { control, handleSubmit, register, setValue, reset } =
    useForm<FormValues>({
      defaultValues: {
        items: [{ productId: "", productType: "", serviceId: "", price: 0 }]
      }
    });

    
  const handleCancelClick = () => {
    navigate("/product-service-map/list");
  };
  useEffect(() => {
    /**
     * Edit Function
     * @param id
     *
     */
    async function getProductById(id: any) {
      try {
        const response: any = await callAPI(``, Method.GET, {}, id);

        if (response && response?.data) {
        }
      } catch (error) {
        console.error("failed to retrieve data", error);
      }
    }
    if (id) {
      getProductById(id);
    }
  }, [id, setValue]);
  const setRequest = async (data: any) => {
    const request = {
      map: data?.items || []
    };
    return request;
  };

  /**
   * Method for Add/Update the data
   * @param data
   */
  const handleData = async (data: any) => {
    try {
      const req: any = await setRequest(data);
      const response: any = await callAPI("Mapping/map", Method.POST, req);
      if (response) {
        showMessage(
          response?.message,
          response.success === true ? "success" : "error"
        );
        reset();
        navigate("/service-product-map/list");
      }
    } catch (e: any) {
      showMessage(e?.error || "Something went wrong", "error");
    }
  };
  const actions: IHeaderListActions[] = [
    {
      type: "icon",
      text: "Cancel",
      size: "medium",
      onClick: handleCancelClick,
      variant: "outlined",
      color: "error",
      icon: <WSIcons.CancelIcon />
    },
    {
      type: "icon",
      text: "Save",
      size: "medium",
      buttonType: "submit",
      variant: "outlined",
      color: "success",
      icon: <WSIcons.SaveIcon />
    }
  ];
  const serviceSource: any = {
    url: "laundry-services/search",
    page: 1,
    pageSize: 10000000,
    filter: [],
    sort: []
  };
  const productSource: any = {
    url: "laundry-products/search",
    page: 1,
    pageSize: 10000000,
    filter: [],
    sort: []
  };
  const transFormDataService = (data: any) => {
    const options: any = [];
    if (data && data?.length > 0) {
      data.map((item: any) => {
        options.push({ label: item.serviceName, value: item.serviceId });
      });
    }
    return options;
  };
  const getServices = async () => {
    const body = {
      page: 1,
      pageSize: 10000000,
      filter: [],
      sort: []
    };
    const response: any = await callAPI(
      "laundry-services/search",
      Method.POST,
      body
    );
    if (response && response.data) {
    }
    return response?.data || [];
  };
  const transFormDataProducts = (data: any) => {
    const options: any = [];
    if (data && data?.length > 0) {
      data.map((item: any) => {
        options.push({ label: item.productName, value: item.productId });
      });
    }
    return options;
  };
  const handleProductChange = async (evt: any, index: number) => {
    const productId = evt?.target?.value;
    const productObj: any = await callAPI(
      `laundry-products`,
      Method.GET,
      null,
      productId
    );
    if (productObj && productObj.data) {
      setValue(
        `items.${index}.productType`,
        productObj.data?.type?.toLowerCase()
      );
    }

    // const serviceResponse: any = await getServices();
    // const existingserviceResponse: any = await callAPI(`laundry-service-products/${productId}/services`, Method.GET)
    // const existingData: any = existingserviceResponse?.data || [];
    // const nonExistingData = serviceResponse.filter(
    //     (service: any) => !existingData.some((existing: any) => existing.serviceId === service.serviceId)
    // );
    // const options: Array<any> = []
    // if (nonExistingData.length === 0) {
    //     showMessage('This product has already added all services', 'warning')
    //     return
    // }
    // nonExistingData.map((item: any) => {
    //     options.push({ label: item.serviceName, value: item.serviceId })
    // })
    // setServiceList(options)
  };
  const handleServiceChange = async (evt: any, index: number) => {
    const serviceId = evt?.target?.value;
    const serviceObj: any = await callAPI(
      `laundry-services`,
      Method.GET,
      null,
      serviceId
    );
    if (serviceObj && serviceObj.data) {
      const rate = serviceObj.data.isWeightBased
        ? serviceObj.data.weightPrice
        : serviceObj.data.basePrice;
      setValue(`items.${index}.price`, rate);
    }

    // const serviceResponse: any = await getServices();
    // const existingserviceResponse: any = await callAPI(`laundry-service-products/${productId}/services`, Method.GET)
    // const existingData: any = existingserviceResponse?.data || [];
    // const nonExistingData = serviceResponse.filter(
    //     (service: any) => !existingData.some((existing: any) => existing.serviceId === service.serviceId)
    // );
    // const options: Array<any> = []
    // if (nonExistingData.length === 0) {
    //     showMessage('This product has already added all services', 'warning')
    //     return
    // }
    // nonExistingData.map((item: any) => {
    //     options.push({ label: item.serviceName, value: item.serviceId })
    // })
    // setServiceList(options)
  };
  const { fields, append, remove } = useFieldArray({
    control,
    name: "items"
  });

  return (
    <>
      <Grid
        item
        container
        spacing={1}
        justifyContent={"start"}
        sx={{
          marginTop: 0,
          marginLeft: 0,
          width: "100%",
          backgroundColor: "#7D79C2",
          borderTopLeftRadius: 5,
          borderTopRightRadius: 5
        }}
      >
        <Grid
          alignContent={"center"}
          style={{ paddingLeft: 20, paddingTop: 0, height: "3rem" }}
          item
          sm={4}
          className="ws-data-grid-lightviolet-title"
        >
          <Typography variant="h6" id="tableTitle" sx={{ fontSize: "1rem" }}>
            Service to Product Mapping
          </Typography>
        </Grid>
      </Grid>
      <form onSubmit={handleSubmit(handleData)}>
        <HeaderList title="Map Service" type="card" actions={actions} />
        <Card sx={{ padding: 2, borderRadius: 2 }}>
          <Grid container spacing={2}>
            {fields.map((field, index) => (
              <React.Fragment key={field.id}>
                <Grid item xs={3}>
                  <WSSelectField
                    label={"Products"}
                    {...register(`items.${index}.productId`)}
                    id={`items.${index}.productId`}
                    name={`items.${index}.productId`}
                    source={productSource}
                    transFormData={transFormDataProducts}
                    onChange={(event) => handleProductChange(event, index)}
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <WSSelectField
                    label={"Type"}
                    {...register(`items.${index}.productType`)}
                    id={`items.${index}.productType`}
                    name={`items.${index}.productType`}
                    options={clientconfig.typeOptions.staticOptionData}
                    // defaultValue={clientconfig.typeOptions.staticOptionData[0].value}
                    // disabled={true}
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={3}>
                  <WSSelectField
                    label={"Service"}
                    {...register(`items.${index}.serviceId`)}
                    id={`items.${index}.serviceId`}
                    name={`items.${index}.serviceId`}
                    source={serviceSource}
                    transFormData={transFormDataService}
                    onChange={(event) => handleServiceChange(event, index)}
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>

                <Grid item xs={2}>
                  <WSTextField
                    label={"Rate"}
                    {...register(`items.${index}.price`)}
                    id={`items.${index}.price`}
                    name={`items.${index}.price`}
                    control={control}
                    rules={{ required: false }}
                  />
                </Grid>
                <Grid item xs={2}>
                  <IconButton onClick={() => remove(index)} color="error">
                    <WSIcons.Delete />
                  </IconButton>
                  {/* <Button onClick={() => remove(index)} color="error" variant="outlined">
                                        Remove
                                    </Button> */}
                </Grid>
              </React.Fragment>
            ))}
          </Grid>

          <Box mt={2}>
            {/* <Button >
                            Add Row
                        </Button> */}
            <IconButton
              sx={{ cursor: "pointer" }}
              onClick={() =>
                append({
                  productId: "",
                  productType: "",
                  serviceId: "",
                  price: 0
                })
              }
            >
              <WSIcons.AddIcon sx={{ color: "#7D79C2" }} />
            </IconButton>
            {/* <Button type="submit" variant="contained" color="primary" sx={{ ml: 2 }}>
                            Submit
                        </Button> */}
          </Box>

          {/* </Grid> */}
        </Card>{" "}
      </form>
    </>
  );
});
